
import React from 'react';
import { activateUser, deactivateUser } from '../api/api';
import { User } from '../api/types';

interface SubordinateActionsProps {
  subordinate: User;
  onActionComplete: () => void;
}

const SubordinateActions: React.FC<SubordinateActionsProps> = ({ subordinate, onActionComplete }) => {
  const handleActivate = async () => {
    try {
      await activateUser(subordinate.id);
      onActionComplete();
    } catch (error) {
      console.error('Failed to activate user:', error);
    }
  };

  const handleDeactivate = async () => {
    try {
      await deactivateUser(subordinate.id);
      onActionComplete();
    } catch (error) {
      console.error('Failed to deactivate user:', error);
    }
  };

  return (
    <div>
      {subordinate.active ? (
        <button
          onClick={handleDeactivate}
          className="text-red-600 hover:text-red-900"
        >
          Deactivate
        </button>
      ) : (
        <button
          onClick={handleActivate}
          className="text-green-600 hover:text-green-900"
        >
          Activate
        </button>
      )}
    </div>
  );
};

export default SubordinateActions;